/** Paesi facenti parte dell'Unione Europea con accesso eIDAS come da https://sp-proxy.eid.gov.it/spproxy/country.jsp */

export const EuCountryCodeList = [
  'BE',
  'HR',
  'CZ',
  'EE',
  'DE',
  'LV',
  'LU',
  'NL',
  'PT',
  'SK',
  'ES',
  'DK'

  // 'EL',
  // 'GR', // La grecia può avere 2 codici -> GR/EL
  // 'LT',
  // 'BG',
  // 'RO',
  // 'FR',
  // 'HU',
  // 'SI',
  // 'MT',
  // 'IT',
  // 'FI',
  // 'CY',
  // 'AT',
  // 'SE',
  // 'IE',
  // 'PL'
];
